import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';

interface LevelData {
    name: string;
    id: number;
    subtopics: Array<LevelData>;
    isOrganisationalLabel: boolean;
    // other properties omitted for brevity
}

interface IdName {
    id: number;
    name: string;
    isOrganisationalLabel: boolean;
}

@Component({
    selector: 'app-toc-settings',
    templateUrl: './toc-settings.component.html',
    styleUrls: ['./toc-settings.component.scss'],
})
export class TocSettingsComponent {
    @Input() topic: any;
    @Output() saveSettingsValue = new EventEmitter<any>();
    upperLevelNames: any;
    faAngleDown = faAngleDown;
    enableParentContext = true;
    topicOutline: any;
    setParentContextValue = false;
    ngOrgValue: boolean | undefined;
    ngArtValue: boolean | undefined;

    constructor(private commonservice: CommonServiceService) {}

    ngOnInit(): void {
        //console.log('the current Id is', JSON.stringify(this.topic));
        const topicOutline = localStorage.getItem('topicOutline');
        // console.log('the topicoutline is', JSON.stringify(topicOutline));
        // const finalData = this.mapParentIdsToNames(this.topic, topicOutline);
        //  console.log("the parents list are",finalData)
        this.checktheParentContextExpandCollapse();
        const findUpperLevelNamesAndIds = (currentLevel: { ParentList: Array<number> }, completeData: LevelData): Array<IdName> => {
            const parentIds = currentLevel.ParentList;
            const idNameArray: Array<IdName> = [];
            // Recursive function to find the id and name based on the id
            const findIdAndNameById = (data: LevelData, id: number): IdName | null => {
                if (data.id === id) {
                    return { id: data.id, name: data.name, isOrganisationalLabel: data.isOrganisationalLabel };
                }
                for (const subtopic of data.subtopics) {
                    const found = findIdAndNameById(subtopic, id);
                    if (found) {
                        return found;
                    }
                }
                return null;
            };

            // Loop through the parentIds and find the corresponding ids and names
            for (const id of parentIds) {
                const idName = findIdAndNameById(completeData, id);
                if (idName) {
                    idNameArray.push(idName);
                }
            }

            return idNameArray;
        };

        if (topicOutline !== null) {
            this.topicOutline = JSON.parse(topicOutline);
            // const upperLevelNames = findUpperLevelNamesAndIds(this.topic, this.topicOutline);
            const upperLevelNamesAndIds = findUpperLevelNamesAndIds(this.topic, this.topicOutline);
            if (this.topic.isOrganisationalLabel) {
                console.log('upperLevelNames are', upperLevelNamesAndIds);
            }

            this.setValuesForParentContext(upperLevelNamesAndIds);
        }

        this.ngOrgValue = this.topic.isOrganisationalLabel;
        this.ngArtValue = this.topic.isArticleCountToZero;
    }

    setValuesForParentContext(upperLevelNames: any) {
        console.log('upperLevelNames', upperLevelNames);
        this.upperLevelNames = upperLevelNames.map((obj: { id: any }) => ({
            ...obj, // Spread operator to keep existing properties
            checked: this.topic.parentRelContextList.includes(obj.id),
        }));
        // this.upperLevelNames = upperLevelNames.map((obj: { id: any; isOrganisationalLabel: boolean }) => ({
        //     ...obj, // Spread operator to keep existing properties
        //     checked: obj.isOrganisationalLabel ? false : this.topic.parentRelContextList.includes(obj.id),
        // }));
    }

    ParentContextSelect(id: number, event: any) {
        const listOfParents = this.upperLevelNames;
        console.log('the ids unchecked are', listOfParents, id, event);
        if (!event.target.checked) {
            this.removeIdfromCurrentLevel(id, this.topic);
            //    this.removeIdfromCurrentLevel(id, this.topicOutline);
        } else {
            this.addIdforCurrentlevel(id, this.topic);
            //   this.addIdforCurrentlevel(id, this.topicOutline);
        }
        this.setParentContextValue = true;
        // this.topic.ParentValueChanged = true;
        //remove the unchecked items from the listOfParents and then from the topicOutline
    }

    removeIdfromAllLevel(id: number, topicOutline: any) {
        this.findAndUpdate(topicOutline, id);
        console.log('the topicoutline are', topicOutline);
    }

    findAndUpdate(node: any, targetId: any) {
        // Check if the current node is the one we are looking for
        if (node.id === targetId) {
            // Call a function to update its children
            this.removeIdFromChildren(node, targetId);
        }

        // Recursively search for the target ID in the subtopics
        if (node.subtopics && node.subtopics.length > 0) {
            for (const subtopic of node.subtopics) {
                this.findAndUpdate(subtopic, targetId);
            }
        }
    }

    removeIdFromChildren(node: any, targetId: any) {
        if (node.subtopics && node.subtopics.length > 0) {
            for (const subtopic of node.subtopics) {
                // Remove targetId from the parentRelContextList
                subtopic.parentRelContextList = subtopic.parentRelContextList.filter((id: any) => id !== targetId);
                subtopic.parentSearchContextList = subtopic.parentSearchContextList.filter((id: any) => id !== targetId);

                this.removeIdFromChildren(subtopic, targetId);
            }
        }
    }

    removeIdfromCurrentLevel(id: number, topicOutline: any) {
        console.log('removeIdfromCurrentLevel called');
        console.log('Coming here for removing', topicOutline, id);
        // const index = topicOutline.parentRelContextList.indexOf(id);
        // if (index !== -1) {
        //     topicOutline.parentRelContextList.splice(index, 1);
        //     topicOutline.parentSearchContextList.splice(index, 1);
        // }
        //commented above line for GA-3541

        if (topicOutline.parentRelContextList) {
            topicOutline.parentRelContextList = topicOutline.parentRelContextList.filter((element: any) => element !== id);
        }

        if (topicOutline.parentSearchContextList) {
            topicOutline.parentSearchContextList = topicOutline.parentSearchContextList.filter((element: any) => element !== id);
        }
        console.log('Coming here for removed', this.topic);
    }

    addIdforCurrentlevel(id: number, topicOutline: any) {
        console.log('addIdforCurrentlevel called');
        if (!topicOutline.parentRelContextList.includes(id)) {
            topicOutline.parentRelContextList.push(id); // Add sam to the array if not found
        }
        if (!topicOutline.parentSearchContextList.includes(id)) {
            topicOutline.parentSearchContextList.push(id); // Add sam to the array if not found
        }
    }

    selectOrgLabel() {
        if (this.topic.isArticleCountToZero) {
            this.topic.isOrganisationalLabel = true;
            this.topic.isArticleCountToZero = false;
        } else {
            this.topic.isOrganisationalLabel = !this.topic.isOrganisationalLabel;
        }

        // if (this.topic.level === 0) {
        //     const obj = {
        //         buttonCLick: false,
        //         articleCountValue: false,
        //     };
        //     this.commonservice.setArticleCountButtonClicked(obj);
        // }
        this.checktheParentContextExpandCollapse();
    }

    checktheParentContextExpandCollapse() {
        if (!this.topic.isArticleCountToZero && !this.topic.isOrganisationalLabel) {
            this.enableParentContext = true;
        } else if (!this.topic.isArticleCountToZero || !this.topic.isOrganisationalLabel) {
            this.enableParentContext = false;
        }
    }

    findAndAssignData(targetId: any, node: any) {
        // if (node.id === targetId) {

        //     return true;
        // }
        this.assignParentRelContextListToDeeperLevels(node, targetId);
        // if (node.subtopics && node.subtopics.length > 0) {
        //     for (const subtopic of node.subtopics) {
        //         console.log("the subtopic ids",subtopic.id)
        //         if (this.findAndAssignData(targetId, subtopic)) {
        //             return true;
        //         }
        //     }
        // }
        return false;
    }

    // Function to assign ParentList to parentRelContextList for all deeper levels
    assignParentRelContextListToDeeperLevels(node: any, targetId: any) {
        if (node.subtopics && node.subtopics.length > 0) {
            for (const subtopic of node.subtopics) {
                if (!subtopic.isOrganisationalLabel && !subtopic.isArticleCountToZero) {
                    subtopic.parentRelContextList = [...subtopic.parentRelContextList, targetId];
                    subtopic.parentSearchContextList = [...subtopic.parentSearchContextList, targetId];
                }
                this.assignParentRelContextListToDeeperLevels(subtopic, targetId);
            }
        }
    }

    AddIdInAllLevel(id: number, topicOutline: any) {
        this.findAndAssignData(id, topicOutline);
        console.log('the values are added here', this.topic);
        console.log('the values are added here', JSON.stringify(this.topic));
    }

    emptyParentContext(alllevel: any, currentLevelId: any) {
        // if (alllevel !== null && alllevel.subtopics.length > 0) {
        //     alllevel.subtopics.forEach((el: any) => {
        //         if (el.id == currentLevelId) {
        //             alllevel.parentRelContextList = [];
        //             alllevel.parentSearchContextList = [];
        //         } else {
        //             this.emptyParentContext(el, currentLevelId);
        //         }
        //     });
        // }
        alllevel.parentRelContextList = [];
        alllevel.parentSearchContextList = [];
    }

    uncheckList() {
        //handle the uncheck list based on the parentcontext list for all subtopics
    }

    removeIdFromParentRelContextList(alllevel: any, currentLevelId: any) {
        const traverseAndRemoveId = (topic: any) => {
            topic.parentRelContextList = topic.parentRelContextList.filter((id: any) => id !== currentLevelId);
            topic.parentSearchContextList = topic.parentSearchContextList.filter((id: any) => id !== currentLevelId);

            if (topic.subtopics && topic.subtopics.length > 0) {
                topic.subtopics.forEach((subtopic: any) => traverseAndRemoveId(subtopic));
            }
        };

        traverseAndRemoveId(alllevel);
        // console.log("the all level alllevel are",alllevel)
    }

    setArticleCount() {
        // if(this.topic.level === 0 && this.topic.subtopics.length > 0){
        //     this.topic.isArticleCountToZero = true;
        // }

        if (this.topic.isOrganisationalLabel) {
            this.topic.isArticleCountToZero = true;
            this.topic.isOrganisationalLabel = false;
        } else {
            this.topic.isArticleCountToZero = !this.topic.isArticleCountToZero;
        }

        // if (this.topic.level === 0) {
        //     const obj = {
        //         buttonCLick: true,
        //         articleCountValue: this.topic.isArticleCountToZero,
        //     };
        //     this.commonservice.setArticleCountButtonClicked(obj);
        // }
        this.checktheParentContextExpandCollapse();
        // handle parent context too
        // this.topic.isArticleCountToZero = !this.topic.isArticleCountToZero;
    }

    // selectLowerlevelParentContext(topicOutline: any, currentLevelId: any) {
    //     console.log("topicOutline and current are",topicOutline,currentLevelId)
    // }

    addIdToParentRelContextList(topicOutline: any, currentLevelId: any) {
        function updateParentRelContextList(node: any, targetId: any): boolean {
            // If the current node matches the target ID
            if (node.id === targetId) {
                // Update all levels of subtopics recursively
                propagateIdToDescendants(node.subtopics, targetId);
                return true; // Stop further traversal once the target is found
            }

            // Recursively search in subtopics
            for (const subtopic of node.subtopics || []) {
                if (updateParentRelContextList(subtopic, targetId)) {
                    return true;
                }
            }
            return false; // Target ID not found
        }

        // Function to propagate the ID to all descendants
        function propagateIdToDescendants(subtopics: any, parentId: any): void {
            for (const subtopic of subtopics) {
                // Add parent ID to the current node if not already present
                if (!subtopic.parentRelContextList.includes(parentId)) {
                    subtopic.parentRelContextList.push(parentId);
                }
                if (!subtopic.parentSearchContextList.includes(parentId)) {
                    subtopic.parentSearchContextList.push(parentId);
                }
                // Recursively propagate to lower levels
                propagateIdToDescendants(subtopic.subtopics || [], parentId);
            }
        }

        console.log('getting called here for article count', this.topic);
        // Start the process from the root
        updateParentRelContextList(topicOutline, currentLevelId);
        // findAndAddToChildren(topicOutline, currentLevelId);
        // localStorage.setItem('topicOutline', JSON.stringify(topicOutline));
    }

    setGlobalRelevance() {
        this.topic.globalRelevance = !this.topic.globalRelevance;
    }

    setProcessNonArticles() {
        this.topic.processNonArticles = !this.topic.processNonArticles;
    }

    setskipRelevance() {
        this.topic.skipRelevance = !this.topic.skipRelevance;
    }

    saveSettings() {
        console.log('this.setParentContextValue', this.setParentContextValue);

        if (this.ngOrgValue === this.topic.isOrganisationalLabel && this.ngArtValue === this.topic.isArticleCountToZero) {
            if (this.setParentContextValue) this.topic.ParentValueChanged = true;
        } else {
            this.topic.ParentValueChanged = true;
        }
        console.log('this.topic.ParentValueChanged', this.topic.ParentValueChanged);
        ///making adjument for org level
        if (this.topic.isOrganisationalLabel) {
            //if the option is highlighted
            // this.enableParentContext = false;
            const currentLevelId = this.topic.id;
            if (this.topicOutline !== null) {
                console.log('coming here inside this condition - 1');

                this.removeIdFromParentRelContextList(this.topic, currentLevelId);
                this.emptyParentContext(this.topic, currentLevelId); //empty current list
                this.removeIdfromAllLevel(currentLevelId, this.topic); //removing this current id from all the children
            }
        } else {
            //if the highlight is removed
            //if(this.topic.level != 0){
            if (!this.setParentContextValue) {
                const currentLevelId = this.topic.id;
                this.AddIdInAllLevel(currentLevelId, this.topic);
            }
            //}
        }

        // making adjument for setArticleCount
        if (this.topic.isArticleCountToZero) {
            // this.enableParentContext = false;
            const currentLevelId = this.topic.id;
            this.emptyParentContext(this.topic, currentLevelId); //to empty current level
            this.addIdToParentRelContextList(this.topic, currentLevelId); //add the id to all below levels

            this.emptyParentContext(this.topicOutline, currentLevelId);
            this.addIdToParentRelContextList(this.topicOutline, currentLevelId);
            //handle checkbox checked all the children
            // this.selectLowerlevelParentContext(this.topicOutline, currentLevelId);
        }

        this.topic = JSON.parse(JSON.stringify(this.topic)); // Deep copy
        console.log('this.topic', this.topic);
        this.saveSettingsValue.emit(this.topic);
        //   if (this.topicOutline !== null) {
        //     let OntologyData = JSON.parse(data);
        //     console.log('Parsed data:', data);
        //     if (this.topicOutline.id == this.topic.id) {
        //         this.topicOutline.processNonArticles = this.topic.processNonArticles;
        //         this.topicOutline.globalRelevance = this.topic.globalRelevance;
        //         this.topicOutline.isArticleCountToZero = this.topic.isArticleCountToZero;
        //         this.topicOutline.isOrganisationalLabel = this.topic.isOrganisationalLabel;
        //         this.topicOutline.skipRelevance = this.topic.skipRelevance;
        //         this.topicOutline.parentRelContextList = this.topic.parentRelContextList;
        //         this.topicOutline.parentSearchContextList = this.topic.parentSearchContextList;
        //         // localStorage.setItem('topicOutline', JSON.stringify(this.topicOutline));
        //     } else {
        //         this.saveValuesforSubtopics(this.topicOutline);
        //         //iterate through subtopics and save the values in local storage
        //     }
        // }
    }

    saveValuesforSubtopics(OntologyData: any) {
        if (OntologyData.subtopics !== null && OntologyData.subtopics.length > 0) {
            OntologyData.subtopics.forEach((element: any) => {
                if (element.id === this.topic.id) {
                    element.processNonArticles = this.topic.processNonArticles;
                    element.globalRelevance = this.topic.globalRelevance;
                    element.isArticleCountToZero = this.topic.isArticleCountToZero;
                    element.isOrganisationalLabel = this.topic.isOrganisationalLabel;
                    element.skipRelevance = this.topic.skipRelevance;
                    element.parentRelContextList = this.topic.parentRelContextList;
                    element.parentSearchContextList = this.topic.parentSearchContextList;
                } else {
                    this.saveValuesforSubtopics(element);
                }
            });
        }
        // localStorage.setItem('topicOutline', JSON.stringify(OntologyData));
    }

    parentContextExpandCollapse() {
        this.enableParentContext = !this.enableParentContext;
    }
}
